<template>
  <div>
    <div class="ui grid">
      <div class="column" style="text-align:center;">
        <button class="ui primary button" @click="login">
          Login
        </button>
      </div>
    </div>    
  </div>
</template>

<script>
export default {
  methods: {
    login() {
      const redirect_url = location.href;
      if (redirect_url) {
        const authUrl = process.env.VUE_APP_AUTH_BASE_URL;
        // 換domain之後改用直接redirect {T7580}
        // const anotherRedirect = encodeURIComponent(`${authUrl}/oauth/ezcast?connect=skip&redirect_url=${encodeURIComponent(redirect_url)}`);
        location.href = `${authUrl}?redirect_url=${encodeURIComponent(redirect_url)}`;
      }
      return;
    },
  },
}
</script>
